import { render, staticRenderFns } from "./Congrats.vue?vue&type=template&id=279618d6&"
import script from "./Congrats.vue?vue&type=script&lang=js&"
export * from "./Congrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279618d6')) {
      api.createRecord('279618d6', component.options)
    } else {
      api.reload('279618d6', component.options)
    }
    module.hot.accept("./Congrats.vue?vue&type=template&id=279618d6&", function () {
      api.rerender('279618d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/configurator/Congrats.vue"
export default component.exports